import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/site/Brand";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("img_admin_token", data?.token ?? "");
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen grid lg:grid-cols-2 bg-[#FAFAFC]" data-testid="admin-login-page">
      <div className="relative hidden lg:block bg-[#0B0424] overflow-hidden grain">
        <img src="/images/caregiver.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0424] to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="font-display text-5xl font-extrabold tracking-tight leading-none">Your network,<br /><span className="text-brand-gradient">at a glance.</span></p>
        </div>
      </div>
      <div className="flex flex-col justify-center px-6 sm:px-16 py-12">
        <Logo className="h-10" />
        <div className="mt-14 max-w-sm w-full">
          <span className="h-12 w-12 rounded-2xl bg-[#14083E] text-white grid place-items-center"><Lock className="w-5 h-5" /></span>
          <h1 className="mt-6 font-display text-4xl font-extrabold tracking-tight text-[#14083E]">Admin sign in</h1>
          <p className="mt-2 text-slate-600">View and manage enrolment applications.</p>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div className="space-y-2">
              <Label htmlFor="a-email">Email</Label>
              <Input id="a-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" data-testid="admin-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="a-pass">Password</Label>
              <Input id="a-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" data-testid="admin-password-input" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-btn"
              className="w-full h-12 rounded-full bg-brand-gradient text-white font-semibold hover:opacity-95 transition-opacity flex items-center justify-center">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
